<template>
  <div style="height: 100%">
    <div v-if="ready" style="height: 100%">
      <SyncPage v-if="$cacheService.caching" />
      <DevicePage
        v-if="deviceUID"
        :token="deviceUID"
        :cache-mode="cacheMode"
        @clearDevice="clearDevice"
      />
      <CodePage v-else @openDevice="openDevice" />
    </div>
  </div>
</template>

<script>
import CodePage from './CodePage';
import DevicePage from './DevicePage';
import SyncPage from './SyncPage';

const urls = {
  development: 'dev-urls.json',
  production: 'urls.json',
};

export default {
  components: { DevicePage, CodePage, SyncPage },
  data() {
    return {
      ready: false,
      deviceUID: null,
      queryParams: {},
      cacheMode: false,
    };
  },
  beforeCreate() {
    this.axios
      .get(urls[process.env.NODE_ENV])
      .then(({ data }) => {
        this.connect(data.api_url, data.websocket_url);
      })
      .catch(() => {
        this.connect();
      });
  },
  methods: {
    openDevice(data) {
      this.deviceUID = data;
    },
    clearDevice() {
      this.deviceUID = null;
      this.parseParams();
      const thisLink = window.location.origin + window.location.pathname;
      let params = '';

      Object.keys(this.queryParams).forEach((param) => {
        if (param === 'api_url' || param === 'socket_url') {
          params = params + `${param}=${this.queryParams[param]}&`;
        }
      });

      if (params) params = params.substring(0, params.length - 1);
      window.history.replaceState(null, null, params ? thisLink + `?${params}` : thisLink);
      localStorage.removeItem(this.$deviceConfig.LOCALSTORAGE_CONSTANTS.USER);
      localStorage.removeItem(this.$deviceConfig.LOCALSTORAGE_CONSTANTS.TOKEN);
      localStorage.removeItem(this.$deviceConfig.LOCALSTORAGE_CONSTANTS.DEVICE_TOKEN);
      localStorage.removeItem(this.$deviceConfig.LOCALSTORAGE_CONSTANTS.REFRESH_TOKEN);
      window.location.reload();
    },
    connect(api = null, socket = null) {
      this.$deviceConfig.API_URL = api;
      this.$deviceConfig.SOCKET_URL = socket;

      this.parseParams();

      this.deviceUID =
        this.queryParams['uid'] ||
        localStorage.getItem(this.$deviceConfig.LOCALSTORAGE_CONSTANTS.DEVICE_TOKEN);
      this.cacheMode = !!(this.queryParams['cache'] || localStorage.getItem('cache') || this.$cacheService.canUseCache);

      if (this.deviceUID)
        localStorage.setItem(
          this.$deviceConfig.LOCALSTORAGE_CONSTANTS.DEVICE_TOKEN,
          this.deviceUID,
        );

      if (this.cacheMode) {
        localStorage.setItem('cache', this.cacheMode);
      }

      const api_url =
        this.$router.currentRoute.query['api_url'] ||
        this.queryParams['api_url'];
      const socket_url =
        this.$router.currentRoute.query['socket_url'] ||
        this.queryParams['socket_url'];

      if (api_url) this.$deviceConfig.API_URL = api_url;
      if (socket_url) this.$deviceConfig.SOCKET_URL = socket_url;

      this.ready = true;
    },
    parseParams() {
      this.queryParams = {};

      let match,
        pl = /\+/g,
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) {
          return decodeURIComponent(s.replace(pl, ' '));
        },
        query = window.location.search.substring(1);

      while ((match = search.exec(query))) this.queryParams[decode(match[1])] = decode(match[2]);
    }
  }
};
</script>
